import React from 'react';
import { Dropdown } from 'Components/input';
import useLanguageOptions from 'Hooks/useLanguageOptions';

const UiLanguageDropdown = ({endpoint = 'user', ...props}) => {
  const { languageOptions, loading } = useLanguageOptions(endpoint);

  if (loading) return <div>Loading...</div>;

  return <Dropdown options={languageOptions} {...props} />;
};

export default UiLanguageDropdown;
